import { USER_EXPERIENCE_UPDATE_SINGLE } from "../components/user-experiences";
import store from "../store";
import { DatabaseInstance } from "./databaseClass";

class UserClass {
  public register = async ({
    username,
    email,
    firstName,
    lastName,
    uid,
    gender,
    dateOfBirth,
    referralCode,
    experienceId,
    agreedToMarketing,
  }: {
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    uid: string;
    gender: string;
    dateOfBirth: string;
    referralCode?: string;
    experienceId?: number;
    agreedToMarketing: boolean;
  }) => {
    const endpoint = "users/register";

    const user = await DatabaseInstance.createRecord({
      endpoint,
      data: {
        username,
        email,
        uid,
        firstName,
        lastName,
        gender,
        dateOfBirth,
        agreedToMarketing,
      },
      params: {
        referralCode,
        experienceId,
      },
      isPublic: true,
    });

    if (!experienceId) return user;

    // Insert a fake record into the store, so it shows the user is attending.
    store.dispatch(
      USER_EXPERIENCE_UPDATE_SINGLE({
        data: {
          id: experienceId,
          experienceId: experienceId,
          userId: user?.id,
        },
      } as any),
    );

    return user;
  };

  public checkUserExists = async (username: string, email: string): Promise<boolean> => {
    const endpoint = `users/does-user-exist/${username}/${email}`;

    return DatabaseInstance.getRecord({ endpoint });
  };
}

const UserInstance = new UserClass();

export { UserInstance };
